import * as yup from 'yup'
import { unformatNumberBR } from 'src/utils'

const requiredField = 'Campo obrigatório!'

export const schema = yup.object().shape({
  weight: yup
    .number()
    .transform((curr, orig) => unformatNumberBR(orig))
    .min(0, 'Pesagem deve ser maior do que 0!')
    .notOneOf([0], 'Pesagem não deve ser 0!')
    .required(requiredField),
  expirationDate: yup
    .date()
    .required(requiredField)
    .transform((curr, orig) => (orig === '' ? null : curr)),
  damageType: yup.string().required(requiredField),
  damageQty: yup
    .number()
    .transform((_, orig) => unformatNumberBR(orig))
    .required(requiredField)
    .min(0, 'Pesagem deve ser no mínimo 0')
    .when('damageType', (damageType, actualSchema) => {
      if (!damageType) {
        return actualSchema
      }

      if (['', 'NENHUM'].includes(damageType)) {
        return actualSchema.oneOf([0], 'Valor deve ser 0!')
      }
      return actualSchema.notOneOf([0], 'Valor não deve ser 0!')
      .max(yup.ref('weight'), 'A quantidade deve ser menor ou igual ao total')
    }),
})
